import {Component, OnInit, ViewChild} from '@angular/core';
import {UsersSharedService} from '../../services/users-shared.service';
import {User} from '../../domain/users/user.model';
import {Principal} from '../../auth/principal.service';
import {SnackBarService} from '../../services/snackbar.service';
import {UserPasswordUpdate} from '../../domain/users/user-password-update.model';
import {FormGroup} from '@angular/forms';
import {GlobalSpinnerService} from '../loader-service/global-spinner.service';
import {RegexUtils} from '../../utils/regex-utils';

@Component({
  selector: 'cm-account',
  templateUrl: './account.component.html',
  // styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {

  public user = new User();
  public password = new UserPasswordUpdate();
  @ViewChild('passwordForm', { static: true })
  passwordForm: FormGroup;
  regex = RegexUtils.passwordRegex;

  constructor(private userService: UsersSharedService,
              private principal: Principal,
              private spinnerService: GlobalSpinnerService,
              private snackBarService: SnackBarService) {
  }

  ngOnInit() {
    Object.assign(this.user, this.principal.getUser());
  }

  updateProfile() {
    this.spinnerService.showLoader();
    this.userService.update(this.user).subscribe(
      (newUser) => {
        this.spinnerService.hideLoader();
        this.snackBarService.success('User updated successfully');
        this.principal.setUser(newUser);
      },
      error => {
        this.spinnerService.hideLoader();
      });
  }

  changePassword() {
    this.spinnerService.showLoader();
    this.userService.changePassword(this.password)
      .subscribe(
        () => {
          this.spinnerService.hideLoader();
          this.passwordForm.reset();
          this.snackBarService.success('Password updated successfully');
        },
        error => {
          this.spinnerService.hideLoader();
          this.snackBarService.error('Password not changed, please try again');
          throw new Error(error);
        }
      );
  }

}
